import { PdfGen, PdfSize, PdfRect, PageGen, PdfUnit } from '../../pdf/pdf';
import { ILayoutListGen } from '../layoutList';
import { IItemCount } from '@educraft/base';
import { OptsList, getListItems } from '../optsList';
import { drawRope } from '../../pdf/board/rope';
import { GLabel } from '../../pdf/glabel';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/cut';
import '../../pdf/draw/label';

/**
 * Provazek (Rope matching) for List layout
 *
 * Layout: 3 landscape strips per page.
 * Students match keys with values by threading a rope.
 *
 * Migrated from C# EduFrame.Order.Generators.Provazek
 */
export class ProvazekSeznam implements ILayoutListGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 3;
  }
  countMax(): number {
    return 12;
  } // Up to 12 items per rope strip for practicality

  public async generate(pdf: PdfGen, opts: OptsList): Promise<void> {
    const items = getListItems(opts);
    if (items.length === 0) return;

    // In List mode, we generate rope strips containing ALL items
    // (up to countMax).
    const count = Math.min(items.length, this.countMax());
    const currentItems = items.slice(0, count);
    const rnd = opts.data.random;
    const totalSheets = 1;

    for (let sIdx = 0; sIdx < totalSheets; sIdx++) {
      // Each sheet takes 2 pages (front/back)
      const page0 = pdf.addPage(true); // landscape
      const page1 = pdf.addPage(true); // landscape

      for (let strip = 0; strip < 3; strip++) {
        const rect = new PdfRect(
          0,
          strip * (PdfSize.A4H.height / 3),
          PdfSize.A4H.width,
          PdfSize.A4H.height / 3
        );

        const gtuples = currentItems.map((it) => ({
          left: GLabel.fromText(it.key),
          right: GLabel.fromText(it.value),
        }));

        const map = [...Array(gtuples.length).keys()];

        drawRope(page0, page1, rect, gtuples, map, rnd, false, 0.4);
      }
    }
  }
}
